export default __webpack_public_path__ + "static/media/auth-error-placeholder.965e91de.svg";